import { ListGroup, ListGroupItem, Badge, Input, InputGroup, InputGroupText } from "reactstrap";
import { CoordinatorGroup } from "../types/PrivateChat";
import { MapPin, Search } from "lucide-react";
import { useMemo, useState } from "react";
import "./CoordinatorGroupList.css";
interface Props {

    groups: CoordinatorGroup[];

    selectedGroup?: string;

    onSelect: (group: CoordinatorGroup) => void;
}

const CoordinatorGroupList = ({
    groups,
    selectedGroup,
    onSelect
}: Props) => {

    const [searchText,setSearchText]=useState("");

    const locationName = (name: string) => {
        const nameList = [];
        if (name.startsWith(',')) {
            nameList[0] = name.split(',')
            return nameList
        }
        else {
            return name
        }

    }

const [showChat, setShowChat] = useState(false);
    const filteredGroups = useMemo(() => {
    const keywords = searchText
        .toLowerCase()
        .split(/[,\s]+/) // Split by comma or whitespace
        .filter(Boolean);

    if (keywords.length === 0) return groups;

    return groups.filter((group) => {
        const groupName = group.groupName?.toLowerCase() || "";
        const location = group.location?.toLowerCase() || "";

        return keywords.every(keyword =>
            groupName.includes(keyword) ||
            location.includes(keyword)
        );
    });
}, [groups, searchText]);


    return (

<>
    <div className="group-search">
        <InputGroup>
            <InputGroupText className="search-icon">
                <Search size={18} />
            </InputGroupText>

            <Input
                type="search"
                placeholder="Search by group or location..."
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
            />
        </InputGroup>
    </div>

    <ListGroup
        flush
        className="group-list"
    >
        {filteredGroups.length > 0 ? (
            filteredGroups.map((group) => (
                <ListGroupItem
                    key={group.groupId}
                    active={selectedGroup === group.groupId}
                    action
                    className="group-item"
                    onClick={() => onSelect(group)}
                >
                    <div className="group-content">

                        <div className="group-info">

                            <div className="group-title">
                                {group.groupName}
                            </div>

                            <div className="group-location">
                                <MapPin size={14} className="me-1" />
                                {locationName(group.location)}
                            </div>

                            <Badge color="dark" pill>
                                {group.lastCustomerName}
                            </Badge>

                        </div>

                        {group.unreadMessages > 0 && (
                            <Badge
                                color="danger"
                                pill
                                className="unread-badge"
                            >
                                {group.unreadMessages}
                            </Badge>
                        )}

                    </div>
                </ListGroupItem>
            ))
        ) : (
            <div className="text-center p-4 text-muted">
                No groups found.
            </div>
        )}
    </ListGroup>
</>

       

    );
};

export default CoordinatorGroupList;